import { createFileRoute, Link } from '@tanstack/react-router'

/* The catch-all. nginx answers an unknown path with dist/404.html and a real
   404 status, and that file is this page: whatever the URL was, the document
   says so instead of pretending the page exists. */
export const Route = createFileRoute('/$')({
  head: () => ({
    meta: [
      { title: 'not found - jfrader' },
      { name: 'description', content: 'no such page on jfrader.com.' },
      { name: 'robots', content: 'noindex' },
    ],
  }),
  component: NotFoundPage,
})

function NotFoundPage() {
  /* No path here on purpose: one file answers every unknown URL, so anything
     that named the path would have to be right for all of them. The address bar
     already says which one it was. */
  return (
    <section className="sec">
      <h2 className="sec__label">404</h2>
      <p className="about">no such file or directory</p>
      <div className="chips" style={{ marginTop: '1rem' }}>
        <Link className="chip" to="/">whoami</Link>
        <Link className="chip" to="/about">about</Link>
        <Link className="chip" to="/products">products</Link>
        <Link className="chip" to="/projects">projects</Link>
        <Link className="chip" to="/tips">tips</Link>
        <Link className="chip" to="/contact">contact</Link>
      </div>
    </section>
  )
}
